// extracted by mini-css-extract-plugin
export var bodySections = "_3v-8";
export var gray = "_3v-7";
export var green = "_3v-4";
export var iconContainer = "_3v-9";
export var iconWidgetContainer = "_3v-1";
export var phoneIcon = "_3v-2";
export var red = "_3v-5";
export var statusDot = "_3v-3";
export var widgetContainer = "_3v-0";
export var yellow = "_3v-6";